import React, { useEffect, useRef } from 'react';
import { Transformer as KonvaTransformer } from 'react-konva';

export const Transformer = ({ selectedShapeName }) => {
  const transformerRef = useRef();

  useEffect(() => {
    if (selectedShapeName) {
      const stage = transformerRef.current.getStage();
      const selectedNode = stage.findOne('.' + selectedShapeName);
      
      if (selectedNode) {
        transformerRef.current.nodes([selectedNode]);
        transformerRef.current.getLayer().batchDraw();
      }
    } else {
      transformerRef.current.nodes([]);
    }
  }, [selectedShapeName]);

  return (
    <KonvaTransformer
      ref={transformerRef}
      boundBoxFunc={(oldBox, newBox) => {
        // Limit resize to minimum size
        if (newBox.width < 20 || newBox.height < 20) {
          return oldBox;
        }
        return newBox;
      }}
      enabledAnchors={[
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right',
        'middle-left',
        'middle-right',
        'top-center',
        'bottom-center',
      ]}
    />
  );
};
